module.exports = __webpack_public_path__ + "ml.svg?ff693a505f163781601968cd7ff13fca";